import React from "react";
import { useNavigate } from "react-router-dom";
import { GAMES, GAME_ORDER } from "../data/games";
import { Button } from "./ui/button";
import { Crown, LogOut, Clover } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const Header = ({ game, onSelectGame, onOpenAuth, onOpenPremium }) => {
  const cfg = GAMES[game];
  const { user, logout, usage } = useAuth();
  const navigate = useNavigate();

  const remaining = () => {
    if (!user) return null;
    if (usage?.is_premium) return "Illimité";
    const used = usage?.counts?.[game] || 0;
    const left = Math.max(0, (usage?.free_limit || 1) - used);
    return `${left} grille gratuite`;
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center text-white shadow-md" style={{ background: cfg.primary }}>
            <Clover className="w-5 h-5" />
          </div>
          <div className="leading-none">
            <div className="font-black text-lg tracking-tight text-slate-900">ProbaLoto</div>
            <div className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Multi-loteries · FDJ</div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {user && (
            <span className="hidden sm:inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full border"
              style={{ borderColor: cfg.secondary, color: cfg.primary, background: cfg.lightBg }} data-testid="freemium-badge">
              {usage?.is_premium && <Crown className="w-3.5 h-3.5 text-[#EAB308]" />}
              {remaining()}
            </span>
          )}
          {!usage?.is_premium && (
            <Button onClick={onOpenPremium} size="sm"
              className="rounded-full font-black text-[#0B132B] bg-[#FFB800] hover:bg-[#EAB308] hover:scale-105 transition-all"
              data-testid="premium-upgrade-cta">
              <Crown className="w-4 h-4 mr-1" /> Premium
            </Button>
          )}
          {user ? (
            <div className="flex items-center gap-2">
              <button onClick={() => navigate("/account")} className="rounded-full transition-transform hover:scale-105" title="Mon compte" data-testid="account-menu-btn">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-8 h-8 rounded-full border" />
                ) : (
                  <div className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-black" style={{ background: cfg.primary }}>
                    {(user.name || user.email)[0].toUpperCase()}
                  </div>
                )}
              </button>
              <Button onClick={logout} variant="ghost" size="icon" className="rounded-full" data-testid="logout-btn">
                <LogOut className="w-4 h-4" />
              </Button>
            </div>
          ) : (
            <Button onClick={onOpenAuth} size="sm" className="rounded-full font-bold text-white" style={{ background: cfg.primary }} data-testid="user-login-btn">
              Connexion
            </Button>
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-3">
        <div className="flex flex-wrap items-center gap-2">
          {GAME_ORDER.map((gid) => {
            const g = GAMES[gid];
            const active = gid === game;
            return (
              <button key={gid} onClick={() => onSelectGame(gid)} data-testid={`game-select-${gid}`}
                className={`whitespace-nowrap px-3.5 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-bold transition-all ${active ? "text-white shadow-md scale-105" : "text-slate-600 bg-slate-100 hover:bg-slate-200"}`}
                style={active ? { background: g.primary } : {}}>
                {g.name}
              </button>
            );
          })}
        </div>
      </div>
    </header>
  );
};
